'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotViolinIcon = function PlotViolinIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M7.313 12.063c-.688-.688-1.25-1.25-1.25-2.375V5.813c0-.375-.25-.688-.625-.688s-.625.313-.625.688v3.875c0 1.125-.625 1.688-1.375 2.375-.813.75-1.813 1.688-1.813 3.688 0 2.188 1 3.188 1.875 3.938.688.688 1.313 1.188 1.313 2.438v3.813c0 .375.25.688.625.688s.625-.313.625-.688v-3.813c0-1.25.563-1.75 1.25-2.438.875-.813 1.813-1.813 1.813-3.938 0-2-1-2.938-1.813-3.688zm-2.125 5.5c-.875 0-1.563-.688-1.563-1.5 0-.875.75-1.563 1.563-1.563s1.563.688 1.563 1.563c0 .813-.688 1.5-1.563 1.5zm12.687.375c-.75-.688-1.25-1.063-1.25-1.875v-3.25c0-.375-.25-.688-.625-.688s-.625.313-.625.688v3.25c0 .813-.438 1.188-1.25 1.875-.875.625-1.875 1.5-1.875 3.188 0 1.938 1 2.75 1.875 3.438.688.563 1.188 1 1.188 1.938v3.188c0 .375.25.688.625.688.438 0 .688-.313.688-.688v-3.188c0-.938.5-1.375 1.25-1.938.813-.688 1.875-1.5 1.875-3.438 0-1.75-1-2.563-1.875-3.188zm-1.687 4.812a1.548 1.548 0 0 1-1.563-1.563c0-.813.75-1.5 1.563-1.5.875 0 1.563.688 1.563 1.5 0 .875-.688 1.563-1.563 1.563zM28.563 9.688c-.75-.813-1.375-1.438-1.375-2.813V2.312c0-.375-.25-.688-.625-.688s-.625.313-.625.688v4.563c0 1.375-.563 2-1.313 2.813-.813.938-1.75 1.938-1.75 4.188 0 2.438.938 3.563 1.813 4.438.75.813 1.25 1.438 1.25 2.938v4.5c0 .375.25.688.625.688.438 0 .688-.313.688-.688v-4.5c0-1.5.625-2.125 1.375-2.938.813-.938 1.75-2 1.75-4.438 0-2.25-.938-3.313-1.813-4.188zM26.875 15.5c-.875 0-1.563-.688-1.563-1.5 0-.875.688-1.563 1.563-1.563.813 0 1.5.688 1.5 1.563 0 .813-.688 1.5-1.5 1.5z' })
    );
};

exports.default = PlotViolinIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotViolinIcon.js
// module id = 695
// module chunks = 0